import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, CONTENT_POINT_SCHEMA, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** A white rounded card: a picture on a pastel tile beside two to four benefit points. */
export const schema: ComponentSchema = {
  type: 'story',
  label: 'Story band',
  description: 'Why shop with you: a picture beside short benefit points.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Picture and points' }],
  commonFields: [
    ...headingFields({ eyebrow: 'Our promise', title: 'Why parents shop with us', subtitle: 'Toys and baby care we would give our own children, at honest prices.' }),
    { key: 'image', label: 'Picture', type: 'image' },
    {
      key: 'points',
      label: 'Points',
      type: 'array',
      itemSchema: CONTENT_POINT_SCHEMA,
      default: [
        { icon: 'secure', title: 'Safety checked', body: 'Every toy is checked for loose parts and sharp edges before it ships.' },
        { icon: 'shipping', title: 'Gift-ready packing', body: 'Packed with care and delivered to your door anywhere in Bangladesh.' },
        { icon: 'support', title: 'Help choosing', body: 'Not sure what suits their age? Call or message us any day.' },
      ],
    },
    { key: 'ctaLabel', label: 'Button text', type: 'localized-string', default: '' },
    { key: 'ctaLink', label: 'Button link', type: 'string', default: '' },
    ...SECTION_STYLE_FIELDS,
  ],
}
